module.exports = __webpack_public_path__ + "static/media/CaptureBBP1.d6135d41.PNG";